import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import Homework from '../../template/HomeworkNew/Homework';
import Load from '../../template/Load/Load';
import StepChange from '../../template/HomeworkNew/StepChange';
import CloseIcon from '../../template/HomeworkNew/CloseIcon';
import { COURSE_URL,ROUND_NAME } from '../../constants';
import { parseQuery, myStorage } from '../../utils/tools';
import { apiDefine } from '../../api/web';
import AXIOS from '../../api/axios';
import clientApi from '../../api/client';
// import Toast from '../../utils/toast';

const queryObj = parseQuery(window.location.search.slice(1));

class HomeworkPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sort: []
        };
        this.shareKeycourseId = 210; // 分享key最初版本即是固定210，后改为根据接口courseId取值
    }
    componentDidMount() {
        this.storage = myStorage;
        apiDefine({ apiName: 'alertViewBack', fn: this.alertViewBack }); // 定义弹框回调方法
        console.log('queryObj===', queryObj);
        AXIOS.getWorkInfoNew({
            query:queryObj.classschid
            // query:'39774'
        },(res,err) => {
            if(err){
                console.log(err);
                clientApi.closeH5Page({reason:'homeworkError'});
            }
            else{
                this.sort = res.sort;
                this.shareKeycourseId = res.courseId || this.shareKeycourseId;
                this.setState({
                    sort: res.sort,
                    completeRender: true
                });
                AXIOS.homeworkDetail({data: {classSchId: queryObj.classschid, type: 0}},(data, error ) => {
                    if(error) console.log(error);
                    else {
                        const [{ index: progress } = {}] = data;
                        if(progress){
                            let dataIndex = progress.toString();
                            // 老数据 index为两位数
                            let type = Number(dataIndex[0]);
                            let roundIndex = this.sort.indexOf(type);
                            let curIndex = Number(dataIndex.slice(1));
                            let subIndex = 2;

                            // 新数据 index为5位数：类型-题号-小题号
                            if(dataIndex.length > 2){
                                curIndex = Number(dataIndex.slice(1, 3));
                                subIndex = Number(dataIndex.slice(3, 5));
                            }

                            // 烟花环节 只做完第一小题进度不加一
                            if(subIndex === 1 && (type === 3 || type === 4)){
                                curIndex = curIndex - 1;
                            }
                            // 当前类型最后一题 跳下一类型
                            if(!res.works[roundIndex][curIndex]){
                                roundIndex = roundIndex + 1 < res.works.length ? roundIndex + 1 : roundIndex;
                                curIndex = 0;
                            }

                            console.log('round', roundIndex, 'sub', subIndex, 'cur', curIndex)

                            this.setState({curIndex, roundIndex});
                            this.storage.setItem('panda_homework_next', JSON.stringify(roundIndex));
                        }
                    }
                });
                this.storage.setItem('panda_homework_sort', JSON.stringify(res.sort));
                this.storage.setItem('panda_homework_questioninfo',JSON.stringify(res.works));
            }
        });
    }

    handleClick = () => {
        clientApi.eventTracking({eventType:'c2_app_HomeWork_Start'});
        const { curIndex, roundIndex } = this.state;
        if(curIndex > 0 || roundIndex > 0){
            clientApi.alertView({
                title: '',
                content: '是否继续上次保存的进度？',
                confirm: '继续',
                cancel: '重做',
                id: 'H5_1007'
            })
        }
        else{
            this.goToWork({curIndex: 1, roundIndex: 0});
            this.setState({ showStepChange: true }, () => {
                this.stepChangeRef.cloudPlay();
            });
        }
    };

    // 前往具体作业
    goToWork = ({curIndex, roundIndex}) => {
        const nextRound = ROUND_NAME[this.sort[Number(roundIndex)]];
        const castleType = this.sort.indexOf(4) > -1 ? '4' : '3';
        setTimeout(() => {
            const { history } = this.props;
            history.push({
                pathname: `${COURSE_URL}/homework/${nextRound}/${curIndex}`,
                search: `${window.location.search}&castletype=${castleType}&courseId=${this.shareKeycourseId}`
            });
        }, 1000);
    }

    // 客户端弹窗回调方法
    alertViewBack = (res) => {
        const data = JSON.parse(res);
        const { curIndex, roundIndex } = this.state;
        console.log(data)
        if(data.select === 'confirm' && data.id === 'H5_1007'){
            this.goToWork({curIndex: curIndex + 1, roundIndex});
        }
        if(data.select === 'cancel' && data.id === 'H5_1007'){
            this.goToWork({curIndex: 1, roundIndex: 0});
        }
        this.setState({ showStepChange: true }, () => {
            this.stepChangeRef.cloudPlay();
        });
    }

    debugClick = index => {
        return clientApi.shareNew({
            type: 2,
            shareByUrl: true,
            shareUrl: window.location.href,
            resource: 'homework'
        })
    }
    render() {
        const { completeRender, stepChange, showStepChange, sort } = this.state;
        return (
            <DocumentTitle title={'课后作业'}>
                <React.Fragment>
                    <CloseIcon closeReason="homeworkDone" />
                    <Homework handleClick={this.handleClick} debugClick={this.debugClick} debug={queryObj.debug} sort={sort} />
                    {/* <StepChange visibale={!!showStepChange} status={stepChange || 'out'} /> */}
                    {showStepChange && (
                        <StepChange status={stepChange || 'out'} ref={com => this.stepChangeRef = com} />
                    )}
                    {!completeRender && <Load type="wide" />}
                </React.Fragment>
            </DocumentTitle>
        );
    }
}

export default HomeworkPage;



// WEBPACK FOOTER //
// ./src/components/homeworkNewPage/HomeworkPage.jsx